const messages = {
    name: 'pt_BR',
    messages: {
        required: 'O campo deve ser preenchido'
    },
    custom: {
        datanascimento: {
            datanasc: 'A data de nascimento está incorreta.',
            required: 'A data deve ser preenchida.',
            idadecompat: 'A data de nascimento não é compatível com o plano selecionado.'
        },
        nome: {
            alpha_spaces: 'O valor inserido é inválido.'
        },
        sobrenome: {
            alpha_spaces: 'O valor inserido é inválido.'
        },
        email: {
            email: 'Informe um endereço de e-mail válido.',
            login_hibrido: 'E-mail ou CPF é inválido.'
        },
        cpf: {
            required: 'O CPF deve ser preenchido.',
            cpf: 'CPF inválido!'
        },
        celular: {
            min: 'O valor inserido deve conter no mínimo 11 caracteres.'
        },
        sexo: {
            required: 'Informe o sexo.'
        },
        password: {
            min: 'O valor inserido deve conter no mínimo 6 caracteres.',
            confirmed: 'As senhas informadas são diferentes.'
        },
        termoscontrato: {
            required: 'Você deve aceitar os termos do contrato para avançar.',
        },
        cep: {
            required: 'Informe seu CEP.',
            prefix: 'Seu CEP não é válido para este plano',
            not_prefix: 'Seu CEP não é válido para este plano',
        },
        estado: {
            required: 'Selecione seu estado.',
        },
        cidade: {
            required: 'Selecione sua cidade.',
        },
        temDependentes: {
            required: 'Selecione uma opção',
            included: 'Opção inválida'
        },
        valorlivre: {
            minimum_price: 'Valor livre incompatível.'
        },
    }
};

export default messages;
